import { NotificationScopeEnum } from "../constants/enums/notificationScope.enum";

export const NotificationScopeOptions = [
  { label: "Tous", value: NotificationScopeEnum.ALL },
  { label: "Utilisateur de la cotation", value: NotificationScopeEnum.USER },
  { label: "Admin", value: NotificationScopeEnum.ADMIN },
  { label: "Aucun", value: NotificationScopeEnum.NONE },
];
